import { EventFull } from '@models/wizbii-event-full/wizbii-event-full.model';
import { createAction, props } from '@ngrx/store';

export const eventFullPutSuccess = createAction('[EventFull] Put success', props<{ eventFull: EventFull }>());
